var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:['navbar navbar-expand navbar-light topbar mb-4 static-top shadow',{ 'system-topbar-color' : _vm.view.systemStatus ==='commission_management' }]},[_c('button',{staticClass:"btn btn-link d-md-none rounded-circle mr-3",on:{"click":_vm.sidebarEvent}},[_c('i',{staticClass:"fa fa-bars"})]),_vm._v(" "),_c('topbar-navbar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795d620d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/TopBar.vue
// module id = null
// module chunks = 